import React from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { H2, Icon, P, Text } from '@mxenabled/mxui'

import { Drawer, useGlobalCopyStore } from '../../../common'
import { type HelpCopy } from '../../../core'

interface SupportSuccessMessageProps {
  copy: HelpCopy
  email: string
  isOpen: boolean
  onBack: () => void
  onClose: () => void
}

const SupportSuccessMessage: React.FC<SupportSuccessMessageProps> = ({
  copy,
  email,
  isOpen,
  onBack,
  onClose,
}) => {
  const { common: commonCopy } = useGlobalCopyStore()
  return (
    <Drawer isOpen={isOpen} onClose={onClose} title={copy.request_support}>
      <Box sx={{ px: 24 }}>
        <Stack sx={{ alignItems: 'center', pb: 24, pt: 80 }}>
          <Icon color="success" fill={true} name="check_circle" size={64} />
        </Stack>
        <Stack sx={{ alignItems: 'center', gap: 16, pb: 48 }}>
          <H2>{copy.request_support_success}</H2>
          <P align="center" variant="body1">
            {copy.request_support_submit_success_message}
          </P>
          <Text bold={true} variant="body1">
            {email}
          </Text>
        </Stack>
        <Button fullWidth={true} onClick={onClose} variant="contained">
          {commonCopy.done_button}
        </Button>
        <Button fullWidth={true} onClick={onBack} sx={{ mt: 8 }}>
          {copy.request_support_institution_back}
        </Button>
      </Box>
    </Drawer>
  )
}

export default SupportSuccessMessage
